import { LANGUAGE_LOCAL } from "constants/AuthConstant";
import {
  SIDE_NAV_LIGHT,
  NAV_TYPE_SIDE,
  DIR_LTR,
} from "constants/ThemeConstant";

export const APP_NAME = "Smenubook";
export const APP_PREFIX_PATH = "/app";
export const AUTH_PREFIX_PATH = "/auth";
export const REDIRECT_URL_KEY = "redirect";
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboards/default`;
export const AUTHENTICATED_WORKSPACE_ENTRY = `${APP_PREFIX_PATH}/dashboards/mergeReport`;
export const AUTHENTICATED_PURCHASING_WORKSPACE_ENTRY = `${APP_PREFIX_PATH}/manager/warehouse`;
export const AUTHENTICATED_ADMIN = `${APP_PREFIX_PATH}/dashboardsAccount/default`;
export const AUTHENTICATED_EMPLOYEE = `${APP_PREFIX_PATH}/sell/pos`;
export const UNAUTHENTICATED_ENTRY = "/login";
export const UNAUTHENTICATED_ADMIN_ENTRY = "/login-admin";
export const AUTHENTICATED_ENTRY_ADMIN = `${APP_PREFIX_PATH}/dashboardsAccount/default`;

export const URL_WEB = "https://smenubook.com/";

const locate = () => {
  let lang = "vi";
  const language = localStorage.getItem(LANGUAGE_LOCAL);
  if (language) {
    lang = language;
  }
  return lang;
};

export const THEME_CONFIG = {
  navCollapsed: false,
  sideNavTheme: SIDE_NAV_LIGHT,
  locale: locate(),
  navType: NAV_TYPE_SIDE,
  topNavColor: "#3e82f7",
  headerNavColor: "",
  mobileNav: false,
  currentTheme: "light",
  direction: DIR_LTR,
  blankLayout: false,
};
